import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn.js';
export function Badge({ tone = 'default', className, children, ...rest }) {
    return (_jsx("span", { className: cn('sak-badge', `sak-badge--${tone}`, className), ...rest, children: children }));
}
/** Maps common ERP status strings to semantic tones. */
export function StatusBadge({ status, ...rest }) {
    const normalized = status.toLowerCase();
    let tone = 'default';
    if (['active', 'posted', 'confirmed', 'success', 'paid'].some((s) => normalized.includes(s))) {
        tone = 'success';
    }
    else if (['pending', 'draft', 'warning'].some((s) => normalized.includes(s))) {
        tone = 'warning';
    }
    else if (['failed', 'cancelled', 'rejected', 'error'].some((s) => normalized.includes(s))) {
        tone = 'danger';
    }
    else if (['info', 'processing'].some((s) => normalized.includes(s))) {
        tone = 'info';
    }
    return _jsx(Badge, { tone: tone, ...rest });
}
export function Avatar({ name, src, size = 'md', className, ...rest }) {
    const initials = name
        ?.split(/\s+/)
        .slice(0, 2)
        .map((p) => p[0])
        .join('');
    return (_jsx("div", { className: cn('sak-avatar', `sak-avatar--${size}`, className), "aria-label": name, ...rest, children: src ? _jsx("img", { src: src, alt: name ?? '' }) : initials }));
}
export function Tooltip({ content, children }) {
    return (_jsxs("span", { className: "sak-tooltip-wrapper", children: [children, _jsx("span", { className: "sak-tooltip", role: "tooltip", children: content })] }));
}
export function Card({ title, actions, children, glass, className, ...rest }) {
    return (_jsxs("div", { className: cn(glass ? 'glass-card' : 'sak-card', className), ...rest, children: [title || actions ? (_jsxs("div", { className: "sak-card__header", children: [title ? _jsx("h3", { className: "sak-card__title", children: title }) : _jsx("span", {}), actions] })) : null, children] }));
}
export function StatCard({ label, value, delta, className, ...rest }) {
    return (_jsxs("div", { className: cn('sak-stat-card', className), ...rest, children: [_jsx("span", { className: "sak-stat-card__label", children: label }), _jsx("span", { className: "sak-stat-card__value", children: value }), delta ? _jsx("span", { className: "sak-stat-card__delta", children: delta }) : null] }));
}
//# sourceMappingURL=Display.js.map